import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule, MatDatepickerModule, MatSelectModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TextMaskModule } from 'angular2-text-mask';

import { SharedModule } from '../../shared/shared.module';

import { PaymentFederalTaxesComponent } from './payment-federal-taxes.component';
import { PaymentSelectTaxComponent } from './payment-select-tax/payment-select-tax.component';
import { PaymentDarfComponent } from './payment-darf/payment-darf.component';
import { DescriptionTaxComponent } from './description-tax/description-tax.component';
import { InfoFieldComponent } from './info-field/info-field.component';
import { PaymentGpsComponent } from './payment-gps/payment-gps.component';
import { PaymentConfirmationDarfComponent } from './payment-confirmation-darf/payment-confirmation-darf.component';
import { PaymentResultDarfComponent } from './payment-result-darf/payment-result-darf.component';
import { PaymentConfirmationGpsComponent } from './payment-confirmation-gps/payment-confirmation-gps.component';
import { PaymentResultGpsComponent } from './payment-result-gps/payment-result-gps.component';

import { PaymentFederalTaxesService } from './payment-federal-taxes.service';

@NgModule({
	imports: [
		CommonModule,
		MatRadioModule,
		MatDatepickerModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		CurrencyMaskModule,
		MatAutocompleteModule,
		MatSelectModule,
		TextMaskModule
	],
	declarations: [
		PaymentFederalTaxesComponent,
		PaymentSelectTaxComponent,
		PaymentDarfComponent,
		DescriptionTaxComponent,
		InfoFieldComponent,
		PaymentGpsComponent,
		PaymentConfirmationDarfComponent,
		PaymentResultDarfComponent,
		PaymentConfirmationGpsComponent,
		PaymentResultGpsComponent
	],
	providers: [PaymentFederalTaxesService]
})
export class PaymentFederalTaxesModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/payment-federal-taxes.module.ts